module.exports = __webpack_public_path__ + "static/media/radius.08bc3eae.svg";